import { Dispatch } from 'react';
import { useFlexLayout, useTable } from 'react-table';

import { IColumnSortingInfo, ITableColumn } from 'types/table';

interface IUseTableHookProps {
  isLoading: boolean;
  columns: ITableColumn[];
  data: Record<string, unknown>[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const useTableHook = (props: IUseTableHookProps) => {
  const { isLoading, columns, data, columnsSorting, sortColumnData } = props;

  const defaultColumn = { width: 150 };
  const tableOptions = { columns, data, defaultColumn, autoResetSelectedRows: false };

  const tableMethods = useTable(tableOptions, useFlexLayout);

  const { getTableProps, headerGroups, rows, prepareRow } = tableMethods;

  const contentProps = { isLoading, data, rows, prepareRow };
  const headerProps = { headerGroups, columnsSorting, sortColumnData };

  return { headerProps, contentProps, getTableProps };
};
